<template>
<div class="chapter">
<div class="inner_page">
<div> <a id="prologue"></a></div>
<h4 class="fronthead1">PROLOGUE</h4>
<div class="top">
<p class="center"><img alt="" height="66" src="html/docimages/image2.jpg" width="92"/></p>
</div>
<p class="textbreak2"><i><span class="dropcap">T</span>he ways of my people, their language, culture and livelihoods, are with each passing moment vanishing off the face of the earth. I am not
  learned enough to give you a history of the travelling life in its entirety. Nor do I wish to burden you with the ‘ethnic cleansing’ story others have written so passionately.
  ‘But’ I hear you ask, ‘just what is a traveller?’</i></p>
<p><i>Well, my friend, in complete honesty, I do not know. Ask me further, ‘Where do you belong?’ I say to you, ‘Wherever the feather falls or the seed is blown.’</i></p>
<p><i>Without feathers, there is no nest, and without seeds, there are no flowers.</i></p>
<p><i>We are the storytellers. Wandering minstrels, respecters of the soil, lovers of family and friends. Once we were your heritage, now we blot your landscape. Soon we will be gone and you will
  have no culture. I will be a ghost of Scotland’s colourful past, but before I fade, let me tell you about my life on the road with my seven beautiful sisters, protective parents and the
  mongrel dog called Tiny.</i></p>
<p><i>I have stories to tell</i>—<i>sad, humorous, outrageous, aye, even unbelievable, but tell them I must. Why? Because with our leaving we take with us to the grave our greatest
  gift</i>—<i>‘the spoken word’.</i></p>
<p><i>The art of storytelling, with which so many travelling folks are gifted, seldom finds its way through the pen. I am grateful to my parents for giving me the ability to do this, and to the
  many hardy souls we met on the road, for without their taking time for tales I would find it impossible to write this book.</i></p>
<p><i>Every person born is a story; from womb to grave we live a tale. Parents tell stories of the time we were babies, then how we grew into teenagers, and so it goes on, a rich tapestry of
  life.</i></p>
<p><i>Although regarded by many as Scotland’s outcasts, travelling people are as true to her soil as the roots of the heather. I proudly cleave to these roots, and preserve her culture and
  traditions.</i></p>
<p><i>And through these pages I claim my rightful place as one of Scotia’s Bairns.</i></p>
<p><i>Come with me, reader, and share a traveller’s campfire. I promise we won’t steal your children or fleece your pocket. You might even get a wee bit closer to understanding
  us.</i></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 008_prologue.vue?b16f9990